import EstimatedValue from '../src/EstimatedValue.tsx';
export default EstimatedValue;
